import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (FM030 / FM033)
// ============================================================

export interface FM033 {
  fm033_01: string;          // 庫位代號 C(5)
  fm033_02: string;          // 產品代號 C(12)
  fm033_03: string;          // 批號 C(12)
  fm033_04: number;          // 項次
  fm033_11: string;          // 庫存分類代號 C(2)
  fm033_12: string;          // 產生原因代號 C(2)
  fm033_13: string;          // 處理方式代號 C(2)
  fm033_14: string | null;   // 預計完成日 DATE
  fm033_15: string;          // 備註
  fm033_21: string | null;   // 登錄時間
}

export interface FM030 {
  fm030_01: string;          // 庫位代號 C(5)
  fm030_02: string;          // 產品代號 C(12)
  fm030_03: string;          // 批號 C(12)
  fm030_04: number;          // 項次流水號
  fm030_11: number;          // 異常類別代號
  fm030_12: string;          // 計量單位代號
  fm030_13: string | null;   // 入庫日期
  fm030_16: number;          // 庫存量
  fm030_17: number;          // 庫存金額
  fm030_18: number;          // 單價
  fm030_51: string;          // 色號代碼
  fm030_52: string;          // 等級
  fm030_511: string;         // 色號名稱（衍生）
  replies?: FM033[];
}

export interface QueryRequest {
  start_loc?: string;
  last_loc?: string;
  start_product?: string;
  last_product?: string;
  start_batch?: string;
  last_batch?: string;
  start_date?: string;
  last_date?: string;
}

export interface UpsertRequest {
  master: FM030;
  details: FM033[];
}

export interface ListResponse {
  data: FM030[];
  total: number;
  page: number;
  pageSize: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API Client
// ============================================================

export const pwm211Api = {
  // List FM030 records with optional filters
  list: async (
    params: QueryRequest,
    page = 1,
    pageSize = 20
  ): Promise<ListResponse> => {
    const p: Record<string, string | number> = { page, pageSize };
    if (params.start_loc) p.start_loc = params.start_loc;
    if (params.last_loc) p.last_loc = params.last_loc;
    if (params.start_product) p.start_product = params.start_product;
    if (params.last_product) p.last_product = params.last_product;
    if (params.start_batch) p.start_batch = params.start_batch;
    if (params.last_batch) p.last_batch = params.last_batch;
    if (params.start_date) p.start_date = params.start_date;
    if (params.last_date) p.last_date = params.last_date;
    const res = await apiClient.get<ListResponse>('/api/pwm211', { params: p });
    return res.data;
  },

  // Get a single FM030 record with its FM033 replies
  get: async (loc: string, product: string, batch: string): Promise<FM030> => {
    const res = await apiClient.get<FM030>(
      `/api/pwm211/${encodeURIComponent(loc)}/${encodeURIComponent(product)}/${encodeURIComponent(batch)}`
    );
    return res.data;
  },

  // Upsert FM033 replies for an FM030 record (Create — same payload as Update)
  create: async (req: UpsertRequest): Promise<FM030> => {
    const res = await apiClient.post<FM030>('/api/pwm211', req);
    return res.data;
  },

  // Replace FM033 replies for an FM030 record
  update: async (
    loc: string,
    product: string,
    batch: string,
    req: UpsertRequest
  ): Promise<FM030> => {
    const res = await apiClient.put<FM030>(
      `/api/pwm211/${encodeURIComponent(loc)}/${encodeURIComponent(product)}/${encodeURIComponent(batch)}`,
      req
    );
    return res.data;
  },

  // Delete all FM033 replies for an FM030 record
  deleteReplies: async (loc: string, product: string, batch: string): Promise<void> => {
    await apiClient.delete(
      `/api/pwm211/${encodeURIComponent(loc)}/${encodeURIComponent(product)}/${encodeURIComponent(batch)}`
    );
  },
};
